import { StaticValues } from '@utils/enums/StaticValues.enum';
import type { FieldStatus } from '@utils/interfaces';

export const shouldShowPrimaryInsurancePlanQuestion = (
  showInsuranceInPatientDetails: boolean,
  primaryInsurancePlanStatus?: FieldStatus,
) =>
  showInsuranceInPatientDetails &&
  primaryInsurancePlanStatus !== StaticValues.FIELD_STATUS_HIDDEN;

export const isPrimaryInsurancePlanRequired = (
  primaryInsurancePlanStatus?: FieldStatus,
) => primaryInsurancePlanStatus !== StaticValues.FIELD_STATUS_OPTIONAL;

export const shouldShowSecondaryInsurancePlanQuestion = (
  secondaryInsurancePlanStatus?: FieldStatus,
) => secondaryInsurancePlanStatus !== StaticValues.FIELD_STATUS_HIDDEN;

export const isSecondaryInsurancePlanRequired = (
  secondaryInsurancePlanStatus?: FieldStatus,
) => secondaryInsurancePlanStatus !== StaticValues.FIELD_STATUS_OPTIONAL;
